import React from 'react'

export default function DerivativeDemo(props) {
    const getRec = props.getDerivativeData;
    return (
        <>
            {getRec ? <>
                <table className="table table-bordered">
                    <thead>
                        <tr className="header-row changefont">
                            <th className="indexname" size="3">Date</th>
                            <th className="ltp" size="3">Volumes(Cr.)</th>
                            <th className="signal" size="3">Nifty(%CH)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getRec.map((item, key) => (
                            <tr key={key}>
                                <td>{item.sdate} </td>
                                <td   >{item.columnValues} </td>
                                <td style={{ 'color': item.color }} >{item.chg}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
                : ''}
        </>
    )
}
